import { useCallback } from "react";
import { useApiQuery, toList } from "../../useApiQuery";

export interface Transaction {
    TRANSACTION_ID?: string;
    RECEIPTNUMBER?: string;
    TRANSACTIONDATE?: string;
    VALIDATIONDATE?: string;
    AMOUNT?: number | string;
    STORE?: string;
    STORE_NAME?: string;
    IDENTIFIER_PERSON?: string;
    TRANSACTIONSOURCE?: string;
    EVENEMENT?: string;
    ACCOUNTVALUE0?: string;
    ACCOUNTHEADVALUE0?: string;
    COUNTLINKOFFER?: string;
    DISCOUNT_AMOUNT?: string | null;
    [key: string]: unknown;
}

const filterTransactions = (raw: unknown): Transaction[] => {
    const list = toList<Transaction>(raw);
    const filtered = list.filter((t) => t.STORE !== undefined || t.TRANSACTION_ID !== undefined);
    return filtered.length > 0 ? filtered : list;
};

const useGetTransactions = () => {
    const { data: transactions, isLoading, error, fetch } = useApiQuery<Transaction[]>(
        "/getTransactionsPerson",
        { initialData: [], transform: filterTransactions }
    );

    const getTransactions = useCallback(
        (personId: string | number) => fetch({ person_id: personId }),
        [fetch]
    );

    return { transactions, isLoading, error, getTransactions };
};

export default useGetTransactions;
